export const WELCOME_MESSAGE =
    "Hi! I'm your AI assistant. I can help you understand the ab initio genome annotation " +
    'results, explain selected transcripts, summarize the currently visible region, and ' +
    'interpret BLAST matches. Click on any transcript in the genome viewer to learn more.';

export const STARTER_PROMPTS: { key: string; text: string; iconName: 'overview' | 'function' | 'blast' }[] = [
    { key: 'overview', text: 'What am I currently looking at?', iconName: 'overview' },
    { key: 'function', text: 'What is the function of the selected transcript', iconName: 'function' },
    { key: 'blast', text: 'Show BLAST results for this region', iconName: 'blast' },
];
